<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Estratégicos"
            description=""
            url="/indicadores-esb"
          />
        </div>
      </div>
      <div class="row">
        <div class="grid-itens">
          <div v-for="(item, index) in cards" :key="index" class="item-flex">
            <router-link :to="item.link">
              <div class="item">
                <i v-if="item.icone !== false" :class="item.icone"></i>
                <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
                <component v-else :is="item.svg" />
                <h3>
                  {{ item.titulo }}
                </h3>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import AtendimentosNaEsb from '@/components/icons/IndicadoresEsb/Estrategicos/AtendimentosNaEsb'
import Criancas from '@/components/icons/IndicadoresEsb/Estrategicos/Criancas'
import Gestantes from '@/components/icons/IndicadoresEsb/Estrategicos/Gestantes'

export default {
  name: 'IndicadoresEsbEstrategicos',
  components: {
    Menu,
    Footer,
    SectionTitle,
    AtendimentosNaEsb,
    Criancas,
    Gestantes,
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.indicadores_esb_estrategicos
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
